import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import React, { ComponentType, useCallback, useEffect, useMemo } from 'react';
import { registerAuth0Getter } from '@travelity/api';
import { useLocation } from 'react-router-dom';

interface AuthenticationGuardProps {
    component: ComponentType;
}

const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
    component,
}) => {
    const location = useLocation();
    const returnTo = location.pathname.startsWith('/accept_invitation')
        ? location.pathname
        : undefined;
    const options = useMemo(() => ({ returnTo }), [returnTo]);

    const Component = useCallback(
        withAuthenticationRequired(component, options),
        [component, options]
    );

    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        registerAuth0Getter(() => getAccessTokenSilently());
    }, [getAccessTokenSilently]);

    return <Component />;
};

export default AuthenticationGuard;
